module.exports = __webpack_public_path__ + "img/8-2.127df15e.jpg";